import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import { burnAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';
import Amount from './FormFields/Amount';
import WalletAddress from './FormFields/WalletAddress';


export default function Mint({ networkID, provider }) {
    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        } else {
            console.log('values',
                form["0"]?.value,
                form["1"]?.value,
            )
            dispatch(burnAsyncThunk({ account: form["1"]?.value, amount: form["0"]?.value, networkID, provider }));
        }
    };
    return (
        <>
            <h1>Burn DBN</h1>
            <p>You can burn DBN of any address. Put the wallet address and amount to Burn.</p>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className='create-new-poll'>
                <div className='row'>
                    <Amount />
                    <WalletAddress />
                    <div className='col-lg-12'>
                        <div className='inner-row'>
                            <CustomButton
                                title="Submit"
                                type="submit"
                                slice={'bank'}
                                action={"burnAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                            />
                        </div>
                    </div>
                </div>
                </div>
            </Form>
        </>
    )
}
